import React from 'react';
import '../Style/FabricationServices.css';

const FabricationServices = () => {
  return (
    <div className="fabrication-container">
      <div className="fabrication-text">
        <h2 className="fabrication-heading">
          <span className="highlight">PCB</span> Fabrication
        </h2>
        <p>
        Automotive Devices offers a comprehensive range of PCB fabrication services designed to meet the exacting
          needs of our customers. By leveraging strong partnerships with both domestic and international PCB
          manufacturers, we are able to offer competitive pricing and flexible solutions, whether for prototyping
          or high-volume production. Our team is skilled at managing all aspects of PCB fabrication, ensuring that
          your boards are manufactured to the highest quality standards.
        </p>
      </div>

      <div className="fabrication-image">
        <img src="/pcs fabri.jpeg" alt="PCB Fabrication Services" />
      </div>
    </div>
  );
};

export default FabricationServices;
